import { CommandProps, Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { BlockTypes, VideoBlockDataItem } from '../../../../models';
import { VideoNodeView } from './VideoNodeView';

interface VideoProps {
  items: VideoBlockDataItem[];
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    videoNode: { insertVideoNode: ({ items }: VideoProps) => ReturnType };
  }
}

export const VideoNode = Node.create({
  name: 'videoNode',
  group: 'block',
  atom: true,

  addAttributes() {
    return { items: [], pastedFiles: [] };
  },

  parseHTML() {
    return [{ tag: BlockTypes.video }];
  },

  renderHTML({ HTMLAttributes }) {
    return [BlockTypes.video, mergeAttributes(HTMLAttributes)];
  },

  addCommands() {
    return {
      insertVideoNode:
        ({ items }: VideoProps) =>
        ({ commands }: CommandProps) => {
          return commands.insertContent({ type: this.name, attrs: { items } });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(VideoNodeView);
  },
});
